(function () {
		// ====== CONFIG (edit these to suit) ======
		var LABEL = 'VIEW OTHER COMPETITIONS';
		var ITEMS = [
			{ target: '#product-media', text: 'Gallery' },
			{ target: '.mobile-details button:nth-child(1)', text: 'Details' },
			{ target: '#feefo-service-review-carousel-widgetId', text: 'Reviews' },
			{ target: '#product--quantity-price', text: 'Entry' },
			// { target: '.mobile-details button:nth-child(3)', text: 'Delivery' }
		];
		var BG = '#222222'; // requested brand background
		// =========================================
	
		// Tiny waiter as Convert may run before Shopify mounts the DOM
		var maxMs = 8000, step = 50, waited = 0;
		function waitFor(sel, cb){
			var el = document.querySelector(sel);
			if (el) return cb(el);
			if (waited >= maxMs) return;
			waited += step; setTimeout(function(){ waitFor(sel, cb); }, step);
		}
	
		waitFor('.media-gallery__viewer .media-viewer__item:nth-child(1)', function(host){
			if (!host || document.getElementById('cro-img-overlay')) return;

			// ---- Build Pill Navigation HTML ----
			var navHTML = ITEMS.map(function(it, idx){
				return [
					'<li class="pillnav__item">',
				'<a class="pillnav__link' + (idx === 0 ? ' pillnav__link--active' : '') + '" data-target="' + it.target + '" href="#">',
					it.text,
				'</a>',
					'</li>'
				].join('');
			}).join('');

			// Create wrapper for pillnav
			var navWrapper = document.createElement('div');
			navWrapper.className = 'pillnav-wrap';
			navWrapper.style.position = 'absolute';
			navWrapper.innerHTML = [
				'<nav class="pillnav" aria-label="Section navigation">',
					'<ul class="pillnav__list" role="list">', navHTML, '</ul>',
				'</nav>'
			].join('');
			var pillNav = navWrapper.querySelector('.pillnav');

			// Try to place in .media-gallery__viewer if it exists
			var gallery = document.querySelector('.media-gallery__viewer .media-viewer__item:nth-child(1)');
			var galleryContainer = document.querySelector('.media-gallery__viewer');
			if(galleryContainer) {
				// Remove any previous nav if present
				var oldWrap = galleryContainer.querySelector('.pillnav-wrap');
				if (oldWrap) {
					oldWrap.remove();
				}
				
				galleryContainer.appendChild(navWrapper);
				// gallery.style.display = 'flex';
				// gallery.style.justifyContent = 'flex-end';
				// gallery.style.alignItems = 'flex-start';
			} else {
				// fallback to announcement bar
				host.innerHTML = '';
				host.appendChild(navWrapper);
			}
			
			if (gallery) {

				// Add Feefo logo if not already present
				if (!gallery.querySelector('.feefo-logo-abs')) {
					var feefoImg = document.createElement('img');
					feefoImg.src = 'https://api.feefo.com/api/logo?merchantidentifier=the-giveaway-guys';
					feefoImg.alt = 'Feefo Reviews';
					feefoImg.className = 'feefo-logo-abs';
					gallery.appendChild(feefoImg);
				}
				// Dynamically select badge image based on amount in <title>
				var badgeAmount = null;
				// Try to find the element with class .product_main_title
				var titleElement = document.querySelector('.product_main_title_cash');

				if (titleElement) {
					// Extract the full text content (including the span)
					var titleText = titleElement.textContent.trim();
					// Remove commas
					titleText = titleText.replace(/,/g, '');
					// Extract the amount — looks for £ followed by 3 to 6 digits
					var match = titleText.match(/£(\d{3,6})/);
					if (match) {
						badgeAmount = match[1];
					}
				}
				function formatBadgeAmount(amount) {
					var num = parseInt(amount, 10);
					if (isNaN(num)) return null;
					var shorthand = (num >= 1000) ? Math.floor(num / 1000) + 'k' : num.toString();
					return shorthand;
				}
				// Base Shopify files URL - replace with your store's actual base URL for files folder
				var shopifyFilesBaseUrl = 'https://cdn.shopify.com/s/files/1/0310/5698/6248/files/';
				var badgeUrl = null;
				if (badgeAmount) {
					var badgeShorthand = badgeAmount;
					if (badgeShorthand) {
						badgeUrl = shopifyFilesBaseUrl + badgeShorthand + '-tgg-badge.png';
					}
				}

				// Add badge if not already present and badgeUrl is set
				if (badgeUrl && !gallery.querySelector('.badge-cash-abs')) {
					var badgeImg = document.createElement('img');
					badgeImg.src = badgeUrl;
					badgeImg.alt = badgeAmount ? ('£' + badgeAmount + ' Badge') : 'Cash Badge';
					badgeImg.className = 'badge-cash-abs';
					gallery.appendChild(badgeImg);
				}
			}


			document.addEventListener('click', function(e) {
				console.log('[pillnav debug] Document click event fired', e.target);
				var link = e.target.closest('.pillnav__link');
				if (link) {
					console.log('[pillnav debug] pillnav__link clicked:', link);
					e.preventDefault();
					// Remove active from all in the same nav
					var nav = link.closest('.pillnav');
					if (nav) {
						nav.querySelectorAll('.pillnav__link').forEach(function(l) {
							l.classList.remove('pillnav__link--active');
						});
					}
					// Add active to clicked
					link.classList.add('pillnav__link--active');
					var targetSel = link.getAttribute('data-target');
					console.log('[pillnav debug] data-target:', targetSel);
					if (targetSel) {
						var targetEl = document.querySelector(targetSel);
						console.log('[pillnav debug] target element:', targetEl);
						if (targetEl) {
							if (targetEl.tagName === 'BUTTON') {
								if (!targetEl.classList.contains('active')) {
									targetEl.click();
								}
							}
							// Calculate offsetTop relative to document
							function getOffsetTopRelativeToDocument(el) {
								var top = 0;
								while (el) {
									top += el.offsetTop;
									el = el.offsetParent;
								}
								return top;
							}
							var scrollTop = getOffsetTopRelativeToDocument(targetEl) - 120;
							console.log('[pillnav debug] scrollTo:', scrollTop);
							window.scrollTo({ top: scrollTop, behavior: 'smooth' });
						} else {
							console.warn('[pillnav debug] No element found for selector:', targetSel);
						}
					}
				}
			});

		});
	})();

	// Utility to wait for multiple selectors
	function waitForAll(selectors, cb) {
		var found = selectors.map(function(sel) { return document.querySelector(sel); });
		if (found.every(Boolean)) return cb.apply(null, found);
		setTimeout(function() { waitForAll(selectors, cb); }, 50);
	}

	// // Move .product-gallery-x.twcss-sticky below .draw-date-container once both exist
	// waitForAll(['.draw-date-container', '.product-gallery-x.twcss-sticky'], function(header, gallery) {
	//   if (header && gallery && header.parentNode) {
	//     header.parentNode.insertBefore(gallery, header.nextSibling);
	//   }
	// });

	// // Move .twcss-w-full below .draw-date-container once both exist
	// waitForAll(['.draw-date-container', '.twcss-w-full header'], function(drawDate, full) {
	//   if (drawDate && full && drawDate.parentNode) {
	//     drawDate.parentNode.insertBefore(full, drawDate.nextSibling);
	//   }
	// });

